import { environment } from '../config/environment';
import { useApiClient } from './api';

export interface PricingData {
    country: string;
    currency: string;
    currencySymbol: string;
    packages: {
        basic: {
            price: number;
            transactions: number;
        };
        standard: {
            price: number;
            transactions: number;
        };
        pro: {
            price: number;
            transactions: number;
        };
        enterprise: {
            price: number;
            transactions: number;
        };
    };
    addons: {
        expertReview: {
            price: number;
        };
        dailySync: {
            price: number;
        };
        portfolioInsights: {
            price: number;
        };
        taxOptimization: {
            price: number;
        };
        weDoEverything: {
            transactions: number;
            price: number;
        };
    };
    extraTransactions: {
        blockSize: number;
        price: number;
    };
}

/**
 * Service for pricing-related API calls
 */
export const usePricingService = () => {
    const apiClient = useApiClient();

    /**
     * Get pricing data for a specific country
     * @param countryCode ISO country code (e.g., 'DE', 'US')
     * @returns Promise with pricing data
     */
    const getPricingData = async (countryCode: string = 'DE'): Promise<PricingData> => {
        try {
            const response = await apiClient.get(`${environment.expressApiUrl}/api/pricing/${countryCode}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching pricing data:', error);
            throw error;
        }
    };

    return {
        getPricingData,
    };
};
